export default "__VITE_ASSET__rPt9fuQA__"